module.exports = __webpack_public_path__ + "2b21b60643b9c9f389c0d25e1c0ed9c8.pdf";